/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Guest-User specific serializer that is limited to the Guest-User
 * specific fields.
 * @export
 * @interface APIGuestUserRequest
 */
export interface APIGuestUserRequest {
    /**
     * 
     * @type {Date}
     * @memberof APIGuestUserRequest
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof APIGuestUserRequest
     */
    repFor?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestUserRequest
     */
    comment?: string;
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof APIGuestUserRequest
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the APIGuestUserRequest interface.
 */
export function instanceOfAPIGuestUserRequest(value: object): value is APIGuestUserRequest {
    return true;
}

export function APIGuestUserRequestFromJSON(json: any): APIGuestUserRequest {
    return APIGuestUserRequestFromJSONTyped(json, false);
}

export function APIGuestUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'repFor': json['rep_for'] == null ? undefined : json['rep_for'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
    };
}

export function APIGuestUserRequestToJSON(value?: APIGuestUserRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'rep_for': value['repFor'],
        'comment': value['comment'],
        'is_active': value['isActive'],
    };
}

